<div
  class="add-to-homescreen strength-modal"
  *ngIf="showModal"
  (click)="onHide($event)"
>
  <div class="add-to-homescreen-wrap">
    <div class="card bg-white">
      <button
        class="btn-link btn text-secondary"
        style="position: absolute; right: 5px; top: 5px"
        tabindex="0"
        (click)="onHide($event)"
      >
        <span class="icon-wrap icon-more"
          ><fa-icon [icon]="['far', 'close']"></fa-icon>
        </span>
      </button>
      <div class="card-body"
      (click)="onNoHide($event)">
        <ng-container [ngSwitch]="exercise">
          <ng-container *ngSwitchCase="'bicepCurl'">
            <h1 class="strength-modal-header">
              <app-strength-icon [exerciseId]="'bicepCurl'"></app-strength-icon>
              Bicep Curl
            </h1>
            <h2>How-to Guide</h2>
            <div>
              <video
                controlslist="nodownload"
                class="strength-modal-content-video"
                id="m205"
                controls=""
                preload=""
                width="100%"
                poster="./assets/img/strength-bicep-curls.jpg"
              >
                <source
                  type="video/mp4"
                  src="{{ environment.staticUrl }}/5f97fb7fabd84.mp4"
                />
              </video>
              <div class="strength-modal-content text-start">
                <p>
                  Hold one weight or container in each hand. Straighten your
                  arms by your side (palms facing out).
                </p>
                <p>
                  Keep your elbows tucked into your chest, bend at your elbows
                  bringing your hands to your shoulders. Repeat.
                </p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'sitToStand'">
            <h1 class="strength-modal-header">
              <app-strength-icon
                [exerciseId]="'sitToStand'"
              ></app-strength-icon>
              Sit-to-stand
            </h1>
            <h2>How-to Guide</h2>
            <div>
              <video
                controlslist="nodownload"
                class="strength-modal-content-video"
                controls=""
                preload=""
                width="100%"
                poster="./assets/img/strength-sit-to-stand.jpg"
              >
                <source
                  type="video/mp4"
                  src="{{ environment.staticUrl }}/5f97fbb39d362.mp4"
                />
              </video>
              <div class="strength-modal-content text-start">
                <p>
                  Sit in a chair, holding your weights in your hands. Make sure
                  the chair is stable and will not move as you stand up. You
                  should choose a firm chair that you do not sink into. Position
                  your feet hip-width apart.
                </p>
                <p>
                  Stand up (try not to use the arms of the chair to help you)
                  then sit down again. Repeat.
                </p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'uprightRows'">
            <h1 class="strength-modal-header">
              <app-strength-icon [exerciseId]="'pullUps'"></app-strength-icon>
              Upright rows
            </h1>
            <h2>How-to Guide</h2>
            <div>
              <video
                controlslist="nodownload"
                class="strength-modal-content-video"
                controls=""
                preload=""
                width="100%"
                poster="./assets/img/strength-upright-rows.jpg"
              >
                <source
                  type="video/mp4"
                  src="{{ environment.staticUrl }}/5f97fb8df3466.mp4"
                />
              </video>
              <div class="strength-modal-content text-start">
                <p>
                  Hold a weight or container in each hand (palms facing in).
                </p>
                <p>
                  Stand with your arms in front of your thighs and draw your
                  hands up to your face until your elbows are pointing outwards
                  at 90°.
                </p>
                <p>Slowly lower. Repeat</p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'stepUps'">
            <h1 class="strength-modal-header">
              <app-strength-icon [exerciseId]="'stepUps'"></app-strength-icon>
              Step Ups
            </h1>
            <h2>How-to Guide</h2>
            <div>
              <video
                controlslist="nodownload"
                class="strength-modal-content-video"
                controls=""
                preload=""
                width="100%"
                poster="./assets/img/strength-upright-rows.jpg"
              >
                <source
                  type="video/mp4"
                  src="{{ environment.staticUrl }}/5f97fbd14e535.mp4"
                />
              </video>
              <div class="strength-modal-content text-start">
                <p>
                  All you need for this exercise is a step (for example, the
                  bottom step of your stairs). When stepping up, your knee
                  should bend no more than a 90º angle and your thigh should be
                  parallel to the floor. Also, make sure your whole foot is
                  firmly placed on the step before stepping up fully.
                </p>
                <p>
                  Step up with one foot and then bring your other foot up so you
                  are standing on the step with both feet. Step down with one
                  foot, then the other. Continue switching the lead foot until
                  you have finished. Repeat.
                </p>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="bg-light more-resources more-resources-strength-modal">
          <ul class="tracker-list">
            <li>
              <a class="task" [routerLink]="['/resources', 6]">
                <span class="tracker-info">
                  <span class="tracker-title"
                    >View the full Strength Resource</span
                  >
                </span>
                <span class="icon-wrap float-end icon-more"
                  ><fa-icon [icon]="['fal', 'arrow-right']"></fa-icon>
                </span>
              </a>
            </li>
          </ul>
          <div class="card w-100 card-instructions"></div>
        </div>
      </div>
    </div>
  </div>
</div>
